import {ReactElement, useContext} from "react";
import {Loading} from "../loading/Loading"
import {SummaryData} from "../../types/SummaryData";
import {useQuery} from 'react-query'
import {showRequestErrorToast} from "../../services/ErrorService";
import "./Summary.css";
import DataRequest from '../../queries/DataRequest'
import { Summary as ReportSummary } from "@idwal/idwal-react-components";
import { useLocation } from "react-router-dom";
import { getPhotos } from "../../queries/photosQueries";
import { getDownloads } from "../../queries/downloadQueries";
import { LoadingShipImage } from "../loading/LoadingShipImage";
import { AppContext } from "../../App";
import { AppContextType } from "../../types/AppContextType";
import { DocumentResponse } from "../../types/responses/documentResponse";


export const Summary = (): ReactElement => {
    const pathname = window.location.pathname;
    const pathContent = pathname.split("/");
    const inspectionId = pathContent[2];
    const { restrictedView } = useContext(AppContext) as AppContextType;

    const locationSearch = useLocation();
    const queryParams = new URLSearchParams(locationSearch.search);
    const section = queryParams.get("section");
    const { data: photoData, isLoading, isError, error: photoError } = getPhotos(inspectionId);
    const { data: documentData } = getDownloads(inspectionId ?? "");

    if (!inspectionId) {
        showRequestErrorToast('summary (id)');
    }

    const {error, data} = useQuery<SummaryData>(['summary'],
        () => DataRequest(inspectionId, "summary"))

if (error) {
        showRequestErrorToast("Summary");
        return <div></div>
    }

    if (isLoading || !photoData) {
        return <LoadingShipImage />;
    }

    if (isError) {
        console.error(photoError);
        showRequestErrorToast("Vessel photos");
        return <div></div>;
    }


    if (data && documentData) {
        // The component library declares every document as present, which is not
        // true of every inspection. It only reads zipElement, and does so with
        // optional chaining, so the cast is safe.
        return <ReportSummary paragraph={data.paragraph} photoData={photoData} documentData={documentData as Required<DocumentResponse>} section={section} restrictedView={restrictedView} />
    }

    return <Loading/>
}
